import { Injectable, ErrorHandler } from '@angular/core';
import { LogService } from './log.service';
import { File360Error } from './error.model';
import { File360Resources } from './resources';

/**
 * This class is an override for the built in ErrorHandle so we can log program exceptions to our log file. 
 */

@Injectable()
export class ErrorExceptionHandler implements ErrorHandler {

    constructor(private log: LogService) { }

    handleError(error: any) {
        if (error) {
            if (error instanceof Error) {
                this.log.logError(new File360Error(0, error.message, error));
            }
            else if (error instanceof File360Error) {
                this.log.logError(error);
            }
            else {
                var exErr = new Error(`${File360Resources.ERR_Unhandled} : ${typeof error}`)
                this.log.logError(new File360Error(File360Error.ERR_UNHANDLED, File360Resources.ERR_Unhandled, exErr));
            }
        }
    }
}
